import { render } from "./ResponsibilitiesHierarchySection.vue?vue&type=template&id=58a01e70"
import script from "./ResponsibilitiesHierarchySection.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesHierarchySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__